// fields/ImageUploadField.js
import React from "react";
import { Form, Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const ImageUploadField = ({
  name,
  label,
  required = false,
  accept = "image/*",
  maxCount = 1,
}) => {
  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("You can only upload image files!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isImage && isLt2M;
  };

  return (
    <Form.Item
      name={name}
      label={label}
      rules={
        required ? [{ required: true, message: `${label} is required.` }] : []
      }
      valuePropName="fileList"
      getValueFromEvent={(e) => {
        if (Array.isArray(e)) {
          return e;
        }
        return e && e.fileList;
      }}
    >
      <Upload
        customRequest={dummyRequest}
        beforeUpload={beforeUpload}
        accept={accept}
        maxCount={maxCount}
        listType="picture"
      >
        <Button icon={<UploadOutlined />}>Upload {label}</Button>
      </Upload>
    </Form.Item>
  );
};

export default ImageUploadField;
